import React from "react";
import Navbar from "../Navbar";
import { Helmet } from "react-helmet";
import Footer from '../components/Footer';
import CookiesBanner from '../components/CookiesBanner';

function AvisoLegal() {
  return (
    <>
    <Helmet>
        <title>Aviso Legal</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <Navbar />
    <div style={{ padding: "2rem", maxWidth: "800px", margin: "0 auto", lineHeight: "1.6", fontSize: "16px" }}>
      <h1>Aviso Legal</h1>
      <p>
  Servicio web informativo que permite seguir precios de productos en Amazon.es y recibir alertas por email cuando éstos bajan de precio.
</p>
      <p><strong>Titular del sitio web:</strong></p>
      <ul>
        <li><strong>Nombre completo:</strong> Enrique Martínez Ferrando</li>
        <li><strong>NIF:</strong> 20165806g</li>
        <li><strong>Dirección fiscal:</strong> Calle de las Madreselvas 34, 46185 La Pobla de Vallbona, Valencia</li>
        <li><strong>Email de contacto:</strong> <a href="mailto:info@avisamesibaja.com">info@avisamesibaja.com</a></li>
        <li><strong>Condición jurídica:</strong> Persona física</li>
      </ul>

        <p><strong>Actividad y afiliación:</strong></p>
        <p>
          Esta página web permite realizar un seguimiento gratuito del precio de productos disponibles en Amazon.es y recibir notificaciones por correo electrónico en caso de bajadas de precio.
        </p>
        <p>
          El titular participa en el Programa de Afiliados de Amazon EU, un programa publicitario diseñado para proporcionar a sitios web una manera de obtener comisiones por publicidad mediante la inclusión de enlaces a Amazon.es. Las compras realizadas a través de estos enlaces pueden generar una comisión, sin coste adicional para el usuario.
        </p>

        <p><strong>Condiciones de uso:</strong></p>
        <p>
          El acceso y utilización del sitio web implica la aceptación plena y sin reservas de las condiciones aquí descritas. El usuario se compromete a utilizar esta plataforma de forma responsable, sin causar daños a los sistemas o emplearla con fines ilícitos, fraudulentos o que impidan el correcto funcionamiento del servicio.
        </p>

        <p><strong>Propiedad intelectual:</strong></p>
        <p>
          Todos los contenidos, textos, imágenes, logotipos y código fuente son propiedad del titular del sitio o cuentan con licencia para su uso. Queda prohibida su reproducción total o parcial sin autorización expresa.
        </p>

        <p><strong>Limitación de responsabilidad:</strong></p>
        <p>
          El titular no garantiza la disponibilidad continua del servicio ni la exactitud absoluta de los precios mostrados, ya que éstos proceden de Amazon y pueden cambiar en cualquier momento sin previo aviso. 
        </p>
        <p>
          El titular no se responsabiliza del mal uso del servicio por parte de los usuarios ni de posibles errores derivados de datos proporcionados por fuentes externas (Amazon).
        </p>

        <p>
          <strong>Nota:</strong> Esta web no está afiliada, patrocinada ni asociada directamente con Amazon. Amazon y su logotipo son marcas registradas de Amazon.com, Inc. o sus afiliados.
        </p>

        <p><strong>Legislación aplicable:</strong></p>
        <p>
          Este aviso legal se rige por la legislación española. Para la resolución de cualquier conflicto que pudiera derivarse del acceso o uso del sitio web, las partes se someten expresamente a los juzgados y tribunales del domicilio del titular del sitio web, salvo disposición legal en contrario.
        </p>

      </div>
      <Footer />
      <CookiesBanner />
    </>
  );
}

export default AvisoLegal;